<template>
  <div>
    <el-card
      class="box-card activity"
      :body-style="{ padding: '0 0 0 0' }"
      v-loading="loading"
      shadow="hover"
    >
      <div slot="header" class="clearfix stats bg-warning">
        <div class="box title">Cumpleaños</div>
        <el-button type="text" class="box">
          <i class="mdi mdi-plus-circle-outline" style="font-size: 24px"></i>
        </el-button>
      </div>

      <div v-if="reportData.length > 0">
        <BirthdayItem
          @open-drawer="handleOpenDrawer"
          v-for="(item, index) in reportData"
          :key="index"
          :name="item.EmployeeName + ' ' + item.EmployeeLastName"
          :image="item.EmployeeImage"
          :formattedDate="item.EmployeeBirthMonthLabel"
          :date="item.EmployeeBirthDay"
          :id="item.EmployeeId"
          :link="true"
        ></BirthdayItem>
      </div>
    </el-card>

    <el-drawer
      size="65%"
      :with-header="false"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="background">
        <!-- Adds blue background to drawer-->

        <!-- Close button -->
        <el-row class="pt-10">
          <el-col :span="22"><p></p></el-col>
          <el-col :span="1">
            <el-button @click="drawer = false" circle
              ><i class="el-icon-close"></i
            ></el-button>
          </el-col>
          <el-col :span="1"><p></p></el-col>
        </el-row>

        <!-- Image card -->
        <el-row class="pt-10 middle-row" :gutter="20">
          <el-col :span="1"><p></p></el-col>

          <el-col :span="7">
            <el-card v-loading="loading">
              <img
                :src="
                  drawerData.imageUrl !== ''
                    ? drawerData.imageUrl
                    : '/static/images/avatar-2.jpg'
                "
                class="avatar"
              />
              <div class="employee-name center-text">
                {{ drawerData.Name + " " + drawerData.LastName }}
              </div>
            </el-card>
          </el-col>

          <!-- Details card -->
          <el-col :span="15">
            <el-card class="" style="" v-loading="loading">
              <h1>Información de contacto</h1>
              <p class="contact-information-label">Nombre</p>
              <p>{{ drawerData.Name }}</p>
              <p></p>
              <p class="contact-information-label">Apellido</p>
              <p>{{ drawerData.LastName }}</p>
              <p class="contact-information-label">Fecha de nacimiento</p>
              <p>{{ drawerBirthday }}</p>
              <p class="contact-information-label">Departamento</p>
              <p>{{ drawerDepartment }}</p>
              <p class="contact-information-label">Extensión</p>
              <p>{{ drawerData.Extension }}</p>
              <p class="contact-information-label">E-mail</p>
              <p>{{ drawerData.Email }}</p>
              <p class="contact-information-label">Teléfono móvil</p>
              <p>{{ drawerData.PhoneNumber }}</p>
            </el-card>
          </el-col>
          <el-col :span="1"></el-col>
        </el-row>

        <!-- Supervisor card -->
        <el-row>
          <el-col :span="1"><p></p></el-col>
          <el-col :span="22">
            <el-card v-loading="loading">
              <h1>Información adicional</h1>
              <p class="contact-information-label">Supervisor</p>
              <BirthdayItem
                :name="drawerSupervisorName"
                :image="drawerSupervisorImage"
                :date="drawerSupervisorDepartment"
                :link="false"
              ></BirthdayItem>
            </el-card>
          </el-col>
          <el-col :span="1"></el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import BirthdayItem from "./BirthdayItem";

export default {
  name: "Birthdays",
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BirthdayItem
  },
  data() {
    return {
      drawer: false,
      loading: false,
      reportData: [],

      // From BirthdayItem - for the drawer
      drawerData: {
        Name: "",
        LastName: "",
        Extension: "",
        Email: "",
        PhoneNumber: ""
      },
      drawerBirthday: "",
      drawerDepartment: "",

      drawerSupervisorName: "",
      drawerSupervisorImage: "/static/images/avatar-2.jpg",
      drawerSupervisorDepartment: "",

      drawerName: ""
    };
  },
  created() {
    this.getReportData();
  },
  methods: {
    async handleOpenDrawer(employeeId, date) {
      this.drawer = true;

      try {
        this.loading = true;

        var response = await this.$http.get(`/api/Employees/${employeeId}`, {
          timeout: 3 * 60 * 1000
        });
        this.drawerData = response.data;

        this.drawerBirthday = date; // Comes from children component BirthdayItem.vue

        let departmentResponse = await this.$http.get(
          `api/Deparments/${this.drawerData.DeparmentId}`
        );
        this.drawerDepartment = departmentResponse.data.Name;

        let supervisorResponse = await this.$http.get(
          `api/Employees/${this.drawerData.SuperVisorID}`
        );
        this.drawerSupervisorName = supervisorResponse.data.FullName;
        this.drawerSupervisorImage = supervisorResponse.data.imageUrl;

        let supervisorDepartment = await this.$http.get(
          `api/Deparments/${this.drawerData.DeparmentId}`
        );
        this.drawerSupervisorDepartment = supervisorDepartment.data.Name;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleClose(done) {
      done();
    },
    async getReportData() {
      try {
        this.loading = true;
        var response = await this.$http.get("/api/MessageApi/GetBirthdays", {
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            SellerCode: this.currentUser.PersonCode,
            EmployeeId: this.employee
          }
        });

        this.reportData = response.data[0].UpcomingBirthdays;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>

<style scoped>
@import "//unpkg.com/element-ui@2.15.1/lib/theme-chalk/index.css";

.avatar {
  /* border-radius: 50%; */
  width: 250px;
  height: 250px;
  border: 1px solid #fff;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.5s;
  margin: 0 auto 40px auto;
}

.center-text {
  text-align: center;
}

.employee-name {
  font-size: 30px;
}

p {
  font-size: 16px;
  margin: 0 0 20px 0;
}

.contact-information-label {
  font-size: 13px;
  color: rgba(128, 128, 128, 0.747);
  margin-bottom: 0px;
}

.background {
  background-image: linear-gradient(210deg, rgba(0, 89, 255, 0.39), white);
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

@media only screen and (max-width: 1600px) {
  .avatar {
    /* border-radius: 50%; */
    width: 200px;
    height: 200px;
    border: 1px solid #fff;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;
    margin: 0 auto 40px auto;
  }

  .employee-name {
    font-size: 25px;
  }

  h1 {
    font-size: 30px;
    margin: 8px 0 12px 0;
  }

  p {
    font-size: 16px;
    margin: 0 0 10px 0;
  }
}

@media only screen and (max-width: 1400px) {
  .avatar {
    /* border-radius: 50%; */
    width: 150px;
    height: 150px;
    border: 1px solid #fff;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;
    margin: 0 auto 40px auto;
  }

  .employee-name {
    font-size: 20px;
  }

  .middle-row {
    margin-top: -15px;
  }

  h1 {
    font-size: 20px;
    margin: 8px 0 12px 0;
  }

  p {
    font-size: 13px;
    margin: 0 0 8px 0;
  }
}

@media only screen and (max-width: 1100px) {
  .avatar {
    /* border-radius: 50%; */
    width: 70px;
    height: 70px;
    border: 1px solid #fff;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;
    margin: 0 auto 40px auto;
  }

  .employee-name {
    font-size: 20px;
  }

  h1 {
    font-size: 20px;
    margin: 8px 0 12px 0;
  }

  p {
    font-size: 13px;
    margin: 0 0 8px 0;
  }
}
</style>
